<template>
  <div id="doctor-dashboard">

    <!-- <div></div> -->
    <div style="margin: 1em; text-align: center;">
      <div>
        <el-select style="width: auto;" class="select-primary" size="large" name="latestStatus" placeholder="Date Range" v-model="dateRange">
          <el-option class="select-primary" value="Today" :label="$t('message.Today')"></el-option>
          <el-option class="select-primary" value="This week" :label="$t('message.This week')"></el-option>
          <el-option class="select-primary" value="This month" :label="$t('message.This month')"></el-option>
          <el-option class="select-primary" value="Last 7 days" :label="$t('message.Last 7 days')"></el-option>
          <el-option class="select-primary" value="Last 30 days" :label="$t('message.Last 30 days')"></el-option>
          <el-option class="select-primary" value="Last 90 days" :label="$t('message.Last 90 days')"></el-option>
        </el-select>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card card-stats card-raised">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-primary">
                      <i class="now-ui-icons ui-2_chat-round"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number ref="appointmentscount" :value="appointmentsCount"></animated-number>
                    </h3>
                    <h6 class="stats-title">{{$t('message.Appointments')}} </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {
  StatsCard,
  Card,
  Table as NTable,
  Checkbox,
  AnimatedNumber,
  LineChart,
} from "src/components";

export default {
  components: {
    Checkbox,
    Card,
    NTable,
    StatsCard,
    AnimatedNumber,
    LineChart,
  },
  data() {
    return {
      dateRange: "Today",
      fromDate: null,
      toDate: null,
      appointmentsCount: 0,
      labordersCount: 0,
    };
  },

  async mounted() {
    // setting date range as today
    let loader = this.$loading.show({
      container: null,
      canCancel: false,
    });

    //setting date range for today
    let end = new Date();
    let start = new Date();
    end = new Date();
    start = new Date();
    start.setHours(0, 0, 0, 0);
    this.fromDate = start;
    this.toDate = end;

    await this.getAppointmentStats();
    loader.hide();
  },

  methods: {
    async getAppointmentStats() {
      let filter = {};
      if (this.dateRange) {
        filter.fromDate = this.fromDate.getTime();
        filter.toDate = this.toDate.getTime();
      }
      try {
        this.appointmentsCount = (
          await this.$store.dispatch("getAppointmentStats", filter)
        ).count;
      } catch (error) {
        console.error(error);
      }
    },
  },

  watch: {
    dateRange: async function () {
      let start;
      let end;
      switch (this.dateRange) {
        case "Today":
          end = new Date();
          start = new Date();
          start.setHours(0, 0, 0, 0);
          this.fromDate = start;
          this.toDate = end;
          break;
        case "This week":
          end = new Date();
          start = new Date();
          let day = start.getDay() + 1;
          start.setHours(24, 0, 0, 0);
          start.setTime(start.getTime() - 3600 * 1000 * 24 * day);
          this.fromDate = start;
          this.toDate = end;
          break;
        case "This month":
          end = new Date();
          start = new Date();
          let month = start.getMonth();
          start.setMonth(month, 1);
          start.setHours(0, 0, 0, 0);
          this.fromDate = start;
          this.toDate = end;
          break;
        case "Last 7 days":
          end = new Date();
          start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          this.fromDate = start;
          this.toDate = end;
          break;
        case "Last 30 days":
          end = new Date();
          start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          this.fromDate = start;
          this.toDate = end;
          break;
        case "Last 90 days":
          end = new Date();
          start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          this.fromDate = start;
          this.toDate = end;
          break;

        default:
          break;
      }
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      await this.getAppointmentStats();
      loader.hide();
      this.$refs.appointmentscount.initAnimation(this.appointmentsCount, 0);
    },
  },

  computed: {
    settings() {
      return this.$store.state.settings;
    },
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
  },
};
</script>

<style scoped>
#doctor-dashboard {
  padding-top: 1em;
}

#doctor-dashboard > .row {
  margin: auto;
}
</style>
